import { useQuery } from '@tanstack/react-query'
import { fetchSummaryCard, fetchRecordsSummary } from './summary-card-api'

/**
 * Resolved summary-card items for a record. Computed on read with TanStack
 * Query caching (08_summary_card.md §8.8). Invalidate ['summary-card', recordId]
 * after a submission save to refresh the at-a-glance values.
 */
export function useSummaryCardQuery(projectId: string | undefined, recordId: string | undefined) {
  return useQuery({
    queryKey: ['summary-card', projectId, recordId],
    queryFn: () => fetchSummaryCard(projectId!, recordId!),
    enabled: !!projectId && !!recordId,
    staleTime: 30_000,
  })
}

/**
 * Batched summary lookup for a page of records (records list rows). One query
 * per page rather than one per row. Keyed by the sorted record IDs so paging /
 * filtering produces a fresh cache entry.
 */
export function useRecordsSummaryQuery(projectId: string | undefined, recordIds: string[]) {
  const key = [...recordIds].sort()
  return useQuery({
    queryKey: ['records-summary', projectId, key],
    queryFn: () => fetchRecordsSummary(projectId!, recordIds),
    enabled: !!projectId && recordIds.length > 0,
    staleTime: 30_000,
  })
}
